"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiKeyActionCreators = exports.ApiKeyActionTypes = void 0;
var ApiKeyActionTypes;
(function (ApiKeyActionTypes) {
    ApiKeyActionTypes["Login"] = "ApiKey.Login";
    ApiKeyActionTypes["Logout"] = "ApiKey.Logout";
    ApiKeyActionTypes["Success"] = "ApiKey.Success";
    ApiKeyActionTypes["Fail"] = "ApiKey.Fail";
    ApiKeyActionTypes["Insert"] = "ApiKey.Insert";
    ApiKeyActionTypes["Delete"] = "ApiKey.Delete";
    ApiKeyActionTypes["GetList"] = "ApiKey.GetList";
    ApiKeyActionTypes["Sign"] = "ApiKey.Sign";
    ApiKeyActionTypes["Load"] = "ApiKey.Load";
    ApiKeyActionTypes["Add"] = "ApiKey.Add";
    ApiKeyActionTypes["Remove"] = "ApiKey.Remove";
    ApiKeyActionTypes["Update"] = "ApiKey.Update";
})(ApiKeyActionTypes = exports.ApiKeyActionTypes || (exports.ApiKeyActionTypes = {}));
class ApiKeyActionCreators {
}
exports.ApiKeyActionCreators = ApiKeyActionCreators;
ApiKeyActionCreators.load = (apiKeys) => ({
    type: ApiKeyActionTypes.Load,
    apiKeys
});
ApiKeyActionCreators.add = (create) => ({
    type: ApiKeyActionTypes.Add,
    create
});
ApiKeyActionCreators.remove = (key) => ({
    type: ApiKeyActionTypes.Remove,
    key
});
ApiKeyActionCreators.update = (update) => ({
    type: ApiKeyActionTypes.Update,
    update,
});
ApiKeyActionCreators.login = (apiLogin) => ({
    type: ApiKeyActionTypes.Login,
    apiLogin
});
ApiKeyActionCreators.logout = () => ({
    type: ApiKeyActionTypes.Logout,
});
ApiKeyActionCreators.insert = (create) => ({
    type: ApiKeyActionTypes.Insert,
    create
});
ApiKeyActionCreators.delete = (apiKeyId) => ({
    type: ApiKeyActionTypes.Delete,
    apiKeyId
});
ApiKeyActionCreators.getList = () => ({
    type: ApiKeyActionTypes.GetList
});
ApiKeyActionCreators.success = () => ({
    type: ApiKeyActionTypes.Success
});
ApiKeyActionCreators.fail = () => ({
    type: ApiKeyActionTypes.Fail
});
//# sourceMappingURL=apikey.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exchange-common/actions/apikey.js
// module id = 89
// module chunks = 0